import styled from "styled-components";

export const LiveMarketTickerWrapper = styled.a`
  display: flex;
  align-items: center;
  min-height: 36px;
  padding-left: clamp(12px, 3vw, 42px);
  background: #1e2521;
  color: #a7aea9;
  font-family: Halenoir, sans-serif;

  .ticker-label {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 7px;
    padding-right: 22px;
    color: #f6f7f6;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;

    svg {
      width: 15px;
      height: 15px;
      color: #22b735;
      strokeWidth: 2.4px;
    }
  }

  .ticker-viewport {
    min-width: 0;
    flex: 1;
    overflow: hidden;

    &:hover .market-ticker-content {
      animation-play-state: paused;
    }
  }

  .market-ticker-content {
    display: flex;
    width: max-content;
    align-items: center;
    gap: 28px;
    white-space: nowrap;
    animation: ticker-scroll 120s linear infinite;
  }

  .ticker-item {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    font-weight: 600;

    .ticker-emoji { font-style: normal; font-size: 14px; line-height: 1; }
    strong { color: #f7f7f7; font-weight: 800; }
    small { margin-left: 1px; color: #b9c0bb; font-size: 7px; font-weight: 500; }
    b { font-size: 10px; font-weight: 700; }
    b.up { color: #12b230; }
    b.down { color: #fa4f4f; }
    b.neutral { color: #a7aea9; }
  }

  .ticker-price-list {
    flex: 0 0 auto;
    padding: 0 clamp(16px, 3vw, 42px) 0 18px;
    background: #1e2521;
    color: #22b435;
    font-size: 10px;
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  @keyframes ticker-scroll {
    from { transform: translateX(0); }
    to { transform: translateX(-50%); }
  }

  @media (max-width: 520px) {
    min-height: 34px;

    .ticker-label { padding-right: 14px; font-size: 10px; }
    .ticker-label svg { width: 13px; height: 13px; }
    .market-ticker-content { gap: 20px; animation-duration: 140s; }
    .ticker-item { font-size: 10px; }
    .ticker-price-list { padding-left: 12px; padding-right: 16px; font-size: 9px; }
  }
`;
